module.exports = __webpack_public_path__ + "img/XF.33f099e0.png";